/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { SolutionTemplate } from "@/components/landing/solution-template";
import { plumbingConfig } from "./plumbing-config";

export function PlumbingSolutionsPageClient() {
  return <SolutionTemplate config={plumbingConfig} />;
}
